<template>
  <div class="wx-code-box">
    <div class="content">
      <img :src="src" alt="" />
      <p>{{ desc }}</p>
    </div>

    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: ""
    },
    desc: {
      type: String,
      default: "微信扫一扫，前往升级权限"
    }
  }
};
</script>

<style lang="scss" scoped>
.wx-code-box {
  position: fixed;
  top: 0;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  margin-left: 400px;
  font-size: 14px;
  color: #666;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  img {
    width: 200px;
    margin-bottom: 12px;
  }
  .content {
    background-color: #fff;
    padding: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rightCode.vue